<template>
    <div>
        <order-bar></order-bar>
        <transition>
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </transition>
    </div>
</template>

<script>
    import OrderBar from "../components/orders/OrderBar";

    export default {
        name: "OrderControl",
        components: {OrderBar},
    }
</script>

<style scoped>

</style>